const INCLUDED_SC_NAVIGATION_TILES_TEST = ['54', '67', '407', '325', '139', '91', '138', '334', '249', '384', '235', '156', '392', '51', '420', '50', '386', '87'];

module.exports = {
    INCLUDED_SC_NAVIGATION_TILES_TEST
};
